<mat-dialog-content>
  <div class="dialog-content">
    <div class="close">
      <button matIconButton mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="user">
      <button
        class="private"
        matMiniFab
        [routerLink]="['/', PROFILE_PATH]"
        mat-dialog-close
      >
        <mat-icon class="private">person_edit</mat-icon>
      </button>
      <div>{{ userService.user().name }}</div>
    </div>
    <mat-divider/>
    <div class="button-holder">
      <button
        matButton="filled"
        [routerLink]="['/', HOME_PATH]"
        mat-dialog-close
      >Hem
      </button>
      <button
        matButton="filled"
        [routerLink]="['/', PROJECTS_PATH]"
        mat-dialog-close
      >Projekt
      </button>
      <button matButton="filled">Admin</button>
    </div>
    @if (!isAdmin()) {
      <mat-divider/>
      <div class="button-holder">
        <button matButton="filled" class="private">Mer om tjänsten</button>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="actions-holder">
    <mat-divider/>
    <div class="actions">
      Logga ut
      <button matIconButton>
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </div>
</mat-dialog-actions>